import Contract from './Contract'

export default Contract
